export default {
  403: {
    title: 'アクセス権限がありません',
    description: '管理者に連絡してください',
  },
};
